import {
  ConsultationTypeActionTypes,
  CONSULTATION_TYPE_FAIL,
  CONSULTATION_TYPE_LOADING,
  CONSULTATION_TYPE_SUCCESS,
  ConsultationTypeState,
  CONSULTATION_TYPE_API_MSG,
  CONSULTATION_TYPE_API_RES,
} from "./ActionTypes";
import { ConsultationTypeResponse } from "./Model";

const initialStateGetPosts: ConsultationTypeState = {
  loading: false,
  consultationTypeRes: {} as ConsultationTypeResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getConsultationTypeListReducer = (
  state = initialStateGetPosts,
  action: ConsultationTypeActionTypes
): ConsultationTypeState => {
  switch (action.type) {
    case CONSULTATION_TYPE_LOADING:
      return {
        ...state,
        loading: true,
        consultationTypeRes: {} as ConsultationTypeResponse,
      };
    case CONSULTATION_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        consultationTypeRes: action.payload,
        successMsg: action.successMsg,
        status: action.status
      };
    case CONSULTATION_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        consultationTypeRes: {} as ConsultationTypeResponse,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CONSULTATION_TYPE_API_MSG:
      return {
        ...state,
        loading: false,
        consultationTypeRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case CONSULTATION_TYPE_API_RES:
      return {
        ...state,
        loading: false,
        consultationTypeRes: {} as ConsultationTypeResponse,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
